export class FolderCloneNotification {
    public folderSourceId: string;

    public viewId: number;

    public cloneCount: number;

    public folderSourceBoxId: string;

    public static fromJson(other: any): FolderCloneNotification {
        const instance = new FolderCloneNotification();
        instance.viewId = other.ViewId;
        instance.folderSourceId = other.FolderSourceId;
        instance.cloneCount = other.CloneCount;
        instance.folderSourceBoxId = other.FolderSourceBoxId;
        instance.viewId = other.ViewId;
        return instance;
    }
}
